import axios from 'axios';

interface ApiErrorData {
  message?: string;
  errors?: Record<string, unknown>;
}

/**
 * Extracts a human-readable message from an unknown promise rejection.
 *
 * Safely narrows axios errors and reads `response.data.message`, then the first
 * string in `response.data.errors`, falling back to `fallback` for anything else
 * (network errors, thrown values, unexpected shapes).
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!axios.isAxiosError(error)) {
    return fallback;
  }

  const data = error.response?.data as ApiErrorData | undefined;
  if (data?.message) {
    return data.message;
  }

  const errors = data?.errors;
  const firstError = errors
    ? Object.values(errors)
        .flat()
        .find((value): value is string => typeof value === 'string')
    : undefined;

  return firstError ?? fallback;
}
